<template>
    <div class="pagemain">
        <div class="title">
            <Icon type="ios-pause" color="#0466dd" />
            我的项目数据
        </div>

        <div class="project_div">
            <div class="project_data" v-for="(item,i) in project_data_list" :key="i">
                <div class="project_name">
                    {{item.company_short_name}}
                </div>
                <div class="project_count">
                    <div class="project_count_num">
                        3
                    </div>
                    <div class="project_count_title">
                        当前待操作
                    </div>
                </div>
                <div class="project_count">
                    <div class="project_count_num">
                        100
                    </div>
                    <div class="project_count_title">
                        当前在职
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { http } from "@/utils/http.js";

export default {
    name: 'my_project_data',
    data() {
        return {
            project_data_list: []

        }
    },
    mounted() {
        // this.get_project_data_list()
    },
    methods: {
        //获取数据列表
        get_project_data_list() {
            var that = this
            var obj = {
            }
            http("post", process.env.VUE_APP_HOST + "/workbench/project_data/my_project_data", obj, true).then(
                (res) => {
                    if (res.code == 0) {
                        that.project_data_list = res.data.project_data_list
                    } else {
                        that.$Message.error({
                            content: res.msg,
                            duration: 3,
                        });
                    }
                }
            ).catch((res) => {

                console.log(res, '请求出错')
            })
        },


    }
}
</script>

<style scoped>
.pagemain {
    padding: 10px;
    background-color: #fff;
}

.project_div {
    height: 400px;
    overflow: auto;
}

.title {
    font-weight: 600;
    color: #0466dd;
    font-size: 15px;
    margin-left: 10px;
}

.ren {
    font-size: 13px;
    font-weight: 400;
}

.project_count_title {
    font-size: 13px;
    color: #666;
}

.project_count_num {
    font-weight: 600;
    font-size: 16px;
    cursor: pointer;
}

.project_count_num:hover {
    color: #2373d4;
}

.project_count {
    width: 120px;
    text-align: center;
    border: 1px solid rgb(238, 238, 238);
    border-radius: 5px;
    margin: 10px;
    padding: 8px 10px 10px 10px;
}

.project_name {
    font-size: 14px;
    color: #333;
    padding: 20px;
    width: 130px;
}

.project_data {
    display: flex;
    align-items: center;
}
</style>